import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { SDUIComponentRenderer } from "../../__internal__/SDUIComponentRenderer/SDUIComponentRenderer";
import { SectionLoggingEventParams } from "../../__internal__/types";
import { SDUIRotatingSectionComponentRenderer } from "./SDUIRotatingSectionComponentRenderer";
export var SDUIRotatingSectionRenderer = function(param) {
    var section = param.section, componentRenderers = param.componentRenderers, sectionLoggingData = param.sectionLoggingData, loadTimingRef = param.loadTimingRef;
    var rotatingSection = section.rotating_section;
    if (!rotatingSection) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "grid min-h-[36px]",
        children: [
            rotatingSection.components.map(function(component) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "invisible col-start-1 row-start-1 h-fit w-full",
                    children: /*#__PURE__*/ _jsx(SDUIComponentRenderer, {
                        isPrimaryContent: true,
                        // We don't want to have any logging in this section
                        // Since it isn't shown to the user
                        component: _object_spread_props(_object_spread({}, component), {
                            logging_data: undefined
                        }),
                        componentRenderers: componentRenderers,
                        sectionLoggingParams: SectionLoggingEventParams.build()
                    }, component.id)
                }, component.id);
            }),
            /*#__PURE__*/ _jsx("div", {
                "data-test-id": "visible-rotating-section-component-renderer",
                className: "col-start-1 row-start-1",
                children: /*#__PURE__*/ _jsx(SDUIRotatingSectionComponentRenderer, {
                    section: section,
                    componentRenderers: componentRenderers,
                    loadTimingRef: loadTimingRef,
                    sectionLoggingData: sectionLoggingData
                })
            })
        ]
    });
};
